import React, { memo } from "react";
import PropTypes from "prop-types";
import { BettoHistoryModalGlobalStyles } from "../../shared/bettoHistoryModalGlobalStyles";
import { BettoContentWrapper as Wrapper } from "./elements";

export const BettoContentWrapper = memo(({ children }) => (
	<>
		<BettoHistoryModalGlobalStyles />
		<Wrapper>{children}</Wrapper>
	</>
));

BettoContentWrapper.displayName = "BettoContentWrapper";

BettoContentWrapper.propTypes = {
	children: PropTypes.node,
};
